/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcCorpactionsCaadminV1PaymentEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_CORPACTIONS_CAADMIN_V1_PAYMENT_EVENT_ENTITY_NAME = 'ixc.corpactions.caadmin.v1.PaymentEvent';
export const ixcCorpactionsCaadminV1PaymentEventEntity = new schema.Entity<IxcCorpactionsCaadminV1PaymentEvent>(IXC_CORPACTIONS_CAADMIN_V1_PAYMENT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcCorpactionsCaadminV1PaymentEvent) => `${entity.metadata?.eventId}` });

